import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "formIsOpen", false);
        Vue.set(state, "gridIsOpen", true);
    },
    setFormOpenEprofileImplantatum(state) {
        state.formIsOpen = true;
        state.gridIsOpen = false;
    },
    setFormCloseEprofileImplantatum(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
    }
}
